<template>
  <div>
    <v-card class="pa-8 px-10 mt-8" elevation="1">
      <v-row>
        <v-col cols="9" class="pa-0">
          <h2 class="font-weight-regular pb-2">Current Extras</h2>
          <p class="body-2 grey--text text--darken-1">This is a list of all your active extras and add-ons.</p>
        </v-col>
        <v-col class="text-right pa-0">
          <v-btn color="primary" outlined :to="{ name: 'place-extras-create' }">ADD EXTRA</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="px-0">
          <extras-data-table :place="place" />
        </v-col>
      </v-row>
    </v-card>
    <bottom-navigation class="mt-12" :back="{ title: 'Rates', to: { name: 'place-rates-manage' } }" :forward="{ title: $t('global-terms.accommodation'), to: { name: 'place-accommodation' } }"></bottom-navigation>
  </div>
</template>

<script>
import ExtrasDataTable from './ExtrasDataTable'
import BottomNavigation from '@/components/layout/BottomNavigation'

export default {
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  components: {
    ExtrasDataTable,
    BottomNavigation,
  },
}
</script>
